export function AdditionalInfo() {
  return (
    <div className="flex flex-col gap-2 py-10">
      <div>
        <img src="/Logo3Legant.png" alt="" />
      </div>
      <span className="text-base text-secondary font-medium">
        3legant is a technology store based in HCMC, Vietnam. Est since 2025.
      </span>
    </div>
  );
}
